import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLinkActive, RouterLink } from '@angular/router';

import {
  IconName,
  IconComponent,
  IconColorDirective,
  HeadingComponent,
} from '@recruitee/user-interface';

export type Breadcrumb = {
  name: string;
  url: string | any[];
  disabled: boolean;
  icon: IconName;
};

@Component({
  selector: 'rt-product-order-header',
  templateUrl: './product-order-header.component.html',
  styleUrls: ['./product-order-header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [HeadingComponent, RouterLinkActive, RouterLink, IconColorDirective, IconComponent],
})
export class ProductOrderHeaderComponent {
  @Input() public header: string;
  @Input() public breadcrumbs: Breadcrumb[] = [];

  public trackByUrl<T extends Breadcrumb>(index: number, item: T): string {
    return `${index}#${item.url}`;
  }
}
